import Vue from "vue";
import Vuetify from "vuetify/lib";
import Croppa from "vue-croppa";

import "vuetify/src/stylus/app.styl";

Vue.use(Vuetify, {
	iconfont: "md"
});

Vue.use(Croppa);
